"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.withI18n = exports.I18nConsumer = exports.useI18n = void 0;

var _react = _interopRequireWildcard(require("react"));

var _i18next = _interopRequireDefault(require("i18next"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _loglevel = _interopRequireDefault(require("loglevel"));

var _formatting = require("@staccx/formatting");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var I18nContext = (0, _react.createContext)({});
var defaultFormat = {
  currency: function currency(value) {
    return (0, _formatting.formatCurrency)(parseInt(value, 10));
  }
};

var Provider = function Provider(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, ["children"]);

  // const [i18n] = useReducer(reducer, props)
  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      ready = _useState2[0],
      setReady = _useState2[1];

  var _useState3 = (0, _react.useState)(props.language),
      _useState4 = _slicedToArray(_useState3, 2),
      language = _useState4[0],
      setLanguage = _useState4[1];

  var changeLanguage =
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(language) {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _i18next["default"].changeLanguage(language);

            case 2:
              setLanguage(language);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function changeLanguage(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var _props$texts = props.texts,
      texts = _props$texts === void 0 ? null : _props$texts,
      _props$languages = props.languages,
      languages = _props$languages === void 0 ? ["en"] : _props$languages,
      _props$formatFunction = props.formatFunctions,
      formatFunctions = _props$formatFunction === void 0 ? {} : _props$formatFunction,
      backend = props.backend,
      _props$backendOptions = props.backendOptions,
      backendOptions = _props$backendOptions === void 0 ? {} : _props$backendOptions,
      _props$debug = props.debug,
      debug = _props$debug === void 0 ? false : _props$debug,
      _props$level = props.level,
      level = _props$level === void 0 ? null : _props$level;

  var initialize =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _loglevel["default"].setLevel(level || (debug ? "DEBUG" : "SILENT"));

              if (backend) {
                _i18next["default"].use(backend);
              }

              _context2.next = 4;
              return _i18next["default"].init(_objectSpread2({}, texts && {
                resources: texts
              }, {
                lng: language,
                debug: debug,
                backend: _objectSpread2({}, backendOptions),
                returnObjects: true,
                saveMissing: true,
                // Must be set to true
                missingKeyHandler: function missingKeyHandler(key) {
                  return null;
                },
                parseMissingKeyHandler: function parseMissingKeyHandler(key) {
                  _loglevel["default"].warn("No translation found for \"".concat(key, "\""));

                  return null;
                },
                interpolation: {
                  format: function format(value, _format, lng) {
                    if (formatFunctions.hasOwnProperty(_format)) {
                      return formatFunctions[_format](value);
                    }

                    if (defaultFormat.hasOwnProperty(_format)) {
                      return defaultFormat[_format](value);
                    }

                    return value;
                  }
                }
              }));

            case 4:
              _loglevel["default"].log("i18n ready to use", _i18next["default"]);

              setReady(true);

            case 6:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function initialize() {
      return _ref3.apply(this, arguments);
    };
  }();

  (0, _react.useEffect)(function () {
    initialize();
  }, []);
  return _react["default"].createElement(I18nContext.Provider, {
    value: {
      texts: texts,
      i18n: _i18next["default"],
      ready: ready,
      languages: languages,
      changeLanguage: changeLanguage
    }
  }, children);
};

Provider.propTypes = {
  children: _propTypes["default"].element.isRequired,
  texts: _propTypes["default"].object,
  language: _propTypes["default"].string.isRequired,
  formatFunctions: _propTypes["default"].object,
  backend: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].object]),
  backendOptions: _propTypes["default"].object,
  debug: _propTypes["default"].bool
};

var useI18n = function useI18n() {
  var value = (0, _react.useContext)(I18nContext);
  var i18n = value.i18n,
      ready = value.ready;

  var translate = function translate(key, data) {
    return i18n.t(key, data);
  };

  var transform = function transform(value) {
    if (!value.hasOwnProperty(i18n.language)) {
      return null;
    }

    return value[i18n.language];
  };

  return (0, _react.useMemo)(function () {
    return _objectSpread2({
      translate: translate,
      transform: transform,
      languages: i18n.languages
    }, value);
  }, [value, ready]);
};

exports.useI18n = useI18n;

var I18nConsumer = function I18nConsumer(_ref4) {
  var children = _ref4.children;
  var props = useI18n();

  if (!children) {
    return null;
  }

  if (!props.ready) {
    return null;
  }

  return children(props);
}; // TODO: Split into seperate files


exports.I18nConsumer = I18nConsumer;

var withI18n = function withI18n(Component) {
  return function (props) {
    return _react["default"].createElement(I18nConsumer, null, function (i18nProps) {
      return _react["default"].createElement(Component, _extends({}, props, i18nProps));
    });
  };
};

exports.withI18n = withI18n;
var _default = Provider;
exports["default"] = _default;